import Swiper, { Navigation, Pagination, A11y } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';

import Plyr from 'plyr';
import plyrSvg from '../images/plyr.svg';
import 'plyr/dist/plyr.css';

// Shared configurations
const SWIPER_A11Y_DE = {
    enabled: true,
    firstSlideMessage: 'Dies ist der erste Eintrag',
    lastSlideMessage: 'Dies ist der letzte Eintrag',
    nextSlideMessage: 'Nächster Eintrag',
    prevSlideMessage: 'Vorheriger Eintrag',
    paginationBulletMessage: 'Gehe zu Eintrag {{index}}',
};

const getNavElements = (container) => ({
    nextEl: container.querySelector('.swiper-button-next'),
    prevEl: container.querySelector('.swiper-button-prev'),
    paginationEl: container.querySelector('.swiper-pagination'),
});

const activePlayers = [];

$(() => {
    // Initialize video players
    const $wrapper = $('.bv-product__video').find('> div');
    $wrapper.each((index, el) => {
        $(el).find('iframe').attr('src', $(el).find('iframe').attr('consent-original-src-_'));

        const player = new Plyr(el, {
            iconUrl: plyrSvg,
            youtube: {
                noCookie: true,
                rel: 0,
                showinfo: 0,
                iv_load_policy: 3,
                modestbranding: 1
            }
        });

        activePlayers.push(player);
    });

    // Related products sliders
    const allSliders = [...$('.swiper-container:not(:has(.swiper-product-gallery,.swiper-product-video-gallery))')];
    allSliders.forEach((slider) => {
        const { nextEl, prevEl, paginationEl } = getNavElements(slider);
        const swiperEl = slider.querySelector('.swiper-product-related');

        new Swiper(swiperEl, {
            modules: [Navigation, Pagination, A11y],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 27,
            breakpoints: {
                480: { slidesPerView: 2 },
                600: { slidesPerView: 2 },
                1025: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
            },
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
            },
            navigation: { nextEl, prevEl },
            a11y: SWIPER_A11Y_DE,
        });
    });

    // Gallery slider
    const gallerySlider = document.querySelector('.swiper-container .swiper-product-gallery');
    if (gallerySlider) {
        const { nextEl, prevEl, paginationEl } = getNavElements(gallerySlider.parentNode);

        new Swiper(gallerySlider, {
            modules: [Navigation, Pagination],
            focusableElements: 'input, select, option, textarea, button, video, label, iframe',
            loop: true,
            slidesPerView: 1,
            noSwipingClass: 'swiper-no-swiping',
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
            },
            navigation: { nextEl, prevEl },
        });
    }

    // Video gallery slider
    const videoSlider = document.querySelector('.swiper-container .swiper-product-video-gallery');
    if (videoSlider) {
        const { nextEl, prevEl, paginationEl } = getNavElements(videoSlider.parentNode);

        const videoSwiper = new Swiper(videoSlider, {
            modules: [Navigation, Pagination, A11y],
            focusableElements: 'input, select, option, textarea, button, video, label, iframe',
            loop: false,
            slidesPerView: 1,
            noSwipingClass: 'swiper-no-swiping',
            pagination: {
                el: paginationEl,
                type: 'bullets',
                clickable: true,
            },
            navigation: { nextEl, prevEl },
            a11y: SWIPER_A11Y_DE,
        });

        videoSwiper.on('slideChangeTransitionEnd', () => {
            activePlayers.filter(p => p.playing).forEach(p => p.pause());
        });
    }

    // Gravity Forms - disable search in dropdowns
    if (typeof gform !== 'undefined') {
        gform.addFilter('gform_chosen_options', (options) => {
            options.disable_search = true;
            return options;
        });

        // gform.utils.addFilter('gform/datepicker/pre_init', ( data ) => {
        //     data.options.helpTextShort = '';
        //     return data; // or { ...data, options: { ...data.options, helpTextShort: '' } }
        // });
    }

});
